import { render } from "./DetailrecrutView.vue?vue&type=template&id=03f78f3c&scoped=true"
import script from "./DetailrecrutView.vue?vue&type=script&lang=js"
export * from "./DetailrecrutView.vue?vue&type=script&lang=js"

import "./DetailrecrutView.vue?vue&type=style&index=0&id=03f78f3c&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f78f3c"]])

export default __exports__